/* tslint:disable */
import {
  Player,
  Game,
  GameEmoji,
  GameCategory,
  Content
} from '../index';

declare var Object: any;
export interface PlayerShareInterface {
  "image"?: string;
  "id"?: any;
  "playerId"?: any;
  "gameId"?: any;
  "gameEmojiId"?: any;
  "categoryId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  "contentId"?: any;
  player?: Player;
  game?: Game;
  gameEmoji?: GameEmoji;
  category?: GameCategory;
  content?: Content;
}

export class PlayerShare implements PlayerShareInterface {
  "image": string;
  "id": any;
  "playerId": any;
  "gameId": any;
  "gameEmojiId": any;
  "categoryId": any;
  "createdAt": Date;
  "updatedAt": Date;
  "contentId": any;
  player: Player;
  game: Game;
  gameEmoji: GameEmoji;
  category: GameCategory;
  content: Content;
  constructor(data?: PlayerShareInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerShare`.
   */
  public static getModelName() {
    return "PlayerShare";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerShare for dynamic purposes.
  **/
  public static factory(data: PlayerShareInterface): PlayerShare{
    return new PlayerShare(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerShare',
      plural: 'PlayerShares',
      path: 'PlayerShares',
      idName: 'id',
      properties: {
        "image": {
          name: 'image',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "playerId": {
          name: 'playerId',
          type: 'any'
        },
        "gameId": {
          name: 'gameId',
          type: 'any'
        },
        "gameEmojiId": {
          name: 'gameEmojiId',
          type: 'any'
        },
        "categoryId": {
          name: 'categoryId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "contentId": {
          name: 'contentId',
          type: 'any'
        },
      },
      relations: {
        player: {
          name: 'player',
          type: 'Player',
          model: 'Player',
          relationType: 'belongsTo',
                  keyFrom: 'playerId',
          keyTo: 'id'
        },
        game: {
          name: 'game',
          type: 'Game',
          model: 'Game',
          relationType: 'belongsTo',
                  keyFrom: 'gameId',
          keyTo: 'id'
        },
        gameEmoji: {
          name: 'gameEmoji',
          type: 'GameEmoji',
          model: 'GameEmoji',
          relationType: 'belongsTo',
                  keyFrom: 'gameEmojiId',
          keyTo: 'id'
        },
        category: {
          name: 'category',
          type: 'GameCategory',
          model: 'GameCategory',
          relationType: 'belongsTo',
                  keyFrom: 'categoryId',
          keyTo: 'id'
        },
        content: {
          name: 'content',
          type: 'Content',
          model: 'Content',
          relationType: 'belongsTo',
                  keyFrom: 'contentId',
          keyTo: 'id'
        },
      }
    }
  }
}
